
  import {
    inject
  } from "vue"
  export default {
    emits: ["done", "update:visible"],
    props: {
      // 弹窗是否打开
      visible: Boolean,
      // 修改回显的数据
      data: Object
    },
    data() {
      return {
        previewImage: "", // 预览路径
        previewVisible: false, // 开启预览
        // 表单数据
        form: {},
        // 提交状态
        loading: false,
        // 文件提交状态
        loadingFile: false,
        // 是否是修改
        isUpdate: false,
        fileList: [],
      };
    },
    watch: {
      data() {
        this.form = Object.assign({}, this.data);
        this.fileList = this.form['attachment'] ? [{
          uid: '-1',
          name: '附件.png',
          status: 'done',
          url: this.form['attachment'] ? this.createImageUrl(this.form) : [],
          thumbUrl: this.form['attachment'] ? this.createImageUrl(this.form) : [],
        }] : []
        if (this.form.status == 2) this.isUpdate = true
        else this.isUpdate = false
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      }
    },
    computed: {
      // 重构文件列表
      getFileList: {
        get() {
          return this.fileList;
        },
        set(val) {
          this.fileList = val.slice(val.length - 1);
        },
      },
    },
    methods: {
      /**
       * 生成图像地址
       */
      createImageUrl(row) {
        return process.env.VUE_APP_STS_FILE_URL + row.attachment;
      },
      // 处理预览
      handlePreview(file) {
        this.previewVisible = true;
        this.previewImage = file.thumbUrl;
      },
      // 上传附件
      handleUpload(resFile) {
        this.loadingFile = true;
        const formData = new FormData();
        formData.append("file", resFile.file);

        this.imgFile = resFile.file;
        this.$http
          .post("/admin/deposit/upload_attachment", formData)
          .then((response) => {
            if (response.status == 200 && response.data.code == 0) {
              const res = response.data;
              this.form.attachment = res.data;
              this.$message.success(this.$t("操作成功"));
              resFile.onSuccess(res.data, resFile.file);
            }
          })
          .catch(() => {
            resFile.onError();
            this.$message.error(this.$t("操作失败"));
            this.fileList = [];
          })
          .finally(() => {
            this.loadingFile = false;
          });
      },
      /* 更新visible */
      updateVisible(value) {
        this.$emit("update:visible", value);
      },
      /**
       * 保存数据
       */
      save() {
        this.$refs.form.validate().then(() => {
          this.loading = true;
          this.$http.post('/admin/cost_bill/update', this.form).then(res => {
            this.loading = false;
            if (res.data.code === 0) {
              this.$message.success(res.data.msg);
              this.form = {};
              this.updateVisible(false);
              this.$emit('done');
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
          });
        }).catch(() => {});
      },
      onClose() {
        this.updateVisible(false);
      }
    },
    setup() {
      const CURRENCY = inject("CURRENCY")
      return {
        CURRENCY
      }
    }
  };
